/* GNUv3 License

Copyright (c) Jacob K. F. Bogers <jkfbogers@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
import * as debug from 'debug';
import { dbinom_raw } from '../binomial/dbinom';
import { ML_ERR_return_NAN, R_D__0, R_D_nonint_check } from '../common/_general';

const { isNaN: ISNAN, isFinite: R_FINITE } = Number;
const { round: R_forceint, log } = Math;

const printer = debug('dgeom');

export function dgeom<T>(xx: T, p: number, giveLog: boolean = false): T {

  const fx: number[] = Array.isArray(xx) ? xx : [xx] as any;

  const result = fx.map(x => {

    let prob: number;

    if (ISNAN(x) || ISNAN(p)) return x + p;

    if (p <= 0 || p > 1) {
      return ML_ERR_return_NAN(printer);
    }

    let rc = R_D_nonint_check(giveLog, x, printer);
    if (rc !== undefined) {
      return rc;
    }
    if (x < 0 || !R_FINITE(x) || p === 0) {
      return R_D__0(giveLog);
    }
    x = R_forceint(x);

    /* prob = (1-p)^x, stable for small p */
    prob = dbinom_raw(0, x, p, 1 - p, giveLog);

    return giveLog ? log(p) + prob : p * prob;
  });

  return result.length === 1 ? result[0] : result as any;
}



// WEBPACK FOOTER //
// ./src/lib/geometric/dgeom.ts